import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../http/authentication.service';


@Injectable({ providedIn: 'root' })
export class RouteGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // console.log('route', route);
        // console.log('state', state);

        const currentUser = this.authenticationService.userInfo;
        if (this.authenticationService.isLoggedIn()) {
            // route.routeConfig.path    // ex: 'encounters'
            // state.url                 // ex: '/encounters/add'

            // const validRouteYN = currentUser.Menu.filter(item => item.AccessPath && item.AccessPath.startsWith(route.routeConfig.path)).length > 0;
            const validRouteYN = this.authenticationService.userInfo.AuthResult.Instance.IsAdminYN
                // || currentUser.Menu.filter(item => item.AccessPath === route.routeConfig.path).length > 0
                || currentUser.Menu.filter(item =>
                    item.AccessPath === route.routeConfig.path
                    || (item.Children && item.Children.filter(childItem => childItem.AccessPath === route.routeConfig.path).length > 0)
                    ).length > 0;
            if (!validRouteYN) {
                this.router.navigate([{ outlets: { primary: '404-not-found', popup: null }} ]);
            }
            return validRouteYN;
        }

        // not logged in so redirect to login page with the return url
        // this.router.navigate([{ outlets: { primary: 'login', popup: null }} ], { queryParams: { returnUrl: state.url }});
        this.router.navigate([{ outlets: { primary: environment.loginPagePath, popup: null }} ], { queryParams: { returnUrl: state.url }});
        return false;
    }

}
